import { Icon } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';
import { MAX_BACKEND_BINS } from '@/tools/statisticsSummary/statisticsSummary.constants';

export interface SummaryReportAlertProps {
  errorMessage?: string;
}

export const SummaryReportAlert: React.FunctionComponent<SummaryReportAlertProps> = ({ errorMessage }) => {
  const { t } = useTranslation();

  // TODO: When CRAB-41628 is addressed, remove this check and use the errorMessage directly
  const tooManyBinsErrorBackend = t('INVESTIGATE_TOOLS.SUMMARY_REPORT.TOO_MANY_BINS_ERROR_BACKEND');
  const isTooManyBinsError = errorMessage?.toLowerCase().includes(tooManyBinsErrorBackend);
  const displayMessage = isTooManyBinsError
    ? t('INVESTIGATE_TOOLS.SUMMARY_REPORT.TOO_MANY_BINS_ERROR', { max: MAX_BACKEND_BINS })
    : errorMessage || t('INVESTIGATE_TOOLS.SUMMARY_REPORT.NO_DATA');
  const tooltipMessage = isTooManyBinsError
    ? t('INVESTIGATE_TOOLS.SUMMARY_REPORT.TOO_MANY_BINS_ERROR_TOOLTIP', { max: MAX_BACKEND_BINS })
    : errorMessage || t('INVESTIGATE_TOOLS.SUMMARY_REPORT.NO_DATA_TOOLTIP');

  return (
    <div className="flexColumnContainer flexCenter mt4">
      <Icon
        icon="fa-exclamation-triangle"
        type="danger"
        large={true}
        tooltip={tooltipMessage}
        extraClassNames="cursorPointer"
      />
      <div className="flexRowContainer flexFill pb1 ml5">
        <strong className="tw-text-sq-danger-color">{displayMessage}</strong>
      </div>
    </div>
  );
};
